module.exports = "ul.paginator{display:inline-flex;display:-webkit-inline-flex;margin:1rem}ul.paginator li{margin:0 0.2rem;border:1px #043d7a solid;border-radius:0.2rem;padding:0.2rem;vertical-align:middle;display:inline-block;color:#043d7a;text-align:center;width:2rem;cursor:pointer}ul.paginator li.disabled{opacity:0.25;cursor:not-allowed}ul.paginator li:not(.disabled):hover{background-color:#043d7a;color:#fff}ul.paginator li.current{background-color:#043d7a;color:#fff;cursor:default}\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/modules/shared/components/paginator/PaginatorComponent.sass
// module id = 116
// module chunks = 0